import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { TellentAssistantMobileService } from '@core/tellent-assistant-mobile-smart-ui';
import { TellentAssistantBrandMarkComponent } from '@core/tellent-assistant-ui';
import { injectDevFlagSignal } from '@core/tellent-dev-flags-logic';
import { TellentAdoptedStylesheetsDirective, TellentThemeDirective } from '@core/tellent-smart-ui';
import { TellentDevFlag, TellentWebComponent } from '@core/tellent-types';

// This custom element only has one consumer — Manage's mobile HR shell (see
// domains/hr/apps/manage/src/modules/TellentClient/TellentAssistantMobileTrigger.tsx) — so it
// renders the real brand mark unconditionally, same as recruitee-mobile's own (non-bridged)
// trigger. `service` (not just `TellentAssistantControlService`) is injected so
// TellentAssistantMobileService's effects, which drive the presenter bridge to the host's sheet,
// actually get instantiated.
@Component({
  // NOTE: `makeTellentSelector` (defineCustomElements) turns the leading "x-" into "tellent-" —
  // it does NOT anchor the replace, so an "x-tellent-..." selector doubles up into
  // "tellent-tellent-...". Keep "tellent" out of this selector; the transform adds it.
  selector: 'x-assistant-mobile-trigger',
  templateUrl: './tellent-assistant-mobile-trigger.component.html',
  styleUrls: ['../../../styles.less', './tellent-assistant-mobile-trigger.component.less'],
  // this attribute lets that outer stylesheet know whether there's anything to paint.
  host: { '[attr.data-enabled]': 'tellentAssistantFlag() || null' },
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentAssistantBrandMarkComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAssistantMobileTriggerWrapComponent {
  protected readonly tellentAssistantFlag = injectDevFlagSignal(TellentDevFlag.TellentAssistant);
  protected readonly service = inject(TellentAssistantMobileService);
}

export type TellentAssistantMobileTriggerWebComponent = TellentWebComponent<
  TellentAssistantMobileTriggerWrapComponent,
  never
>;
